import React, { Component } from 'react';

import Section from './Section';

const RenaperIntroduction = ({ onFinish }) => {
  return (<div style={{
    position: "relative",
    display: "block",
    width: "100%",
    height: "100%",
    overflowY: "scroll",
    background: "#0a2540",
  }}>
    <Section className="intro_form">
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
          <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/auto-facil-logo.png`)} />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
          <h3><b>Validación Identidad</b></h3>
        </div>
        <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">
          <div className='pvc-form'>
            <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center renaper-message">
              <h4><b>Para validar tu identidad es necesario que tengas tu DNI a mano.</b></h4>
              <p>Asegurate de estar en un lugar tranquilo y con buena luz.</p>
            </div>
            <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">
              <span>
                <p style={{
                  fontFamily: "Rubik,sans-serif!important",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "150%",
                }}>
                  <i className="fa fa-check icon-check" ariaHidden="true"></i> Validamos tu identidad
                </p>
                <p style={{
                  fontFamily: "Rubik,sans-serif!important",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "150%",
                }}>
                  <i className="fa fa-check icon-check" ariaHidden="true"></i> Escaneamos tu DNI
                </p>
                <p style={{
                  fontFamily: "Rubik,sans-serif!important",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "150%",
                }}>
                  <i className="fa fa-check icon-check" ariaHidden="true"></i> Chequeamos tus datos
                </p>
              </span>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                <button
                  type="submit"
                  className="btn btn-warning btn-lg pd-button pd-form"
                  onClick={(event) => {
                    event.preventDefault();
                    onFinish();
                  }}>
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  </div>)
}

module.exports = RenaperIntroduction;



/** WEBPACK FOOTER **
 ** ./src/components/RenaperIntroduction.js
 **/